var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"accent"},on:{"click":_vm.preview}},'v-btn',attrs,false),on),[_vm._v("Preview")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }